import { APIS } from "utils/constants";
import { axiosInstance } from "./index";

export type IRequestDemoParams = {
  firstName: string;
  lastName: string;
  email: string;
  companyName: string;
  companySize: string;
};

export const requestDemo = async (data: IRequestDemoParams) => {
  const url = APIS.DEMO.REQUEST_DEMO;
  try {
    const response = await axiosInstance.post(url, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
